import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

import type {
  TQLGraphRequest,
  TQLGraphResponse,
} from '@/entities/srm/tql-query';

import type { Template } from '@/entities/dashboards/dashboard-widget/@x/tql-query';
import type { MatcherWrapper } from '@/entities/srm/tql-query';
import type {
  ReportValues,
  TreeExportRequest,
  TreeNode,
  TreeQueryID,
  TreeRequest,
  TreeResponse,
} from '@/entities/srm/tql-query';
import { Tree } from '@/shared/lib/utils/tree/types';

const defaultOptions = {
  baseURL: '/api/srm/v4',
};
export class TQLGraphAPI {
  static getGraph(payload: TQLGraphRequest, options?: AxiosRequestConfig) {
    return srmInstance.post<TQLGraphResponse>(`/tql/graph`, payload, {
      ...defaultOptions,
      ...options,
    });
  }
  static getCachedGraph(
    id: string,
    filter?: Template['filter'],
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<TQLGraphResponse>(
      `/tql/graph/${id}/cached`,
      filter,
      {
        ...defaultOptions,
        ...options,
      },
    );
  }

  static validateConditions(
    payload: { conditions: MatcherWrapper },
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post('/graph/conditions/validate', payload, {
      ...options,
    });
  }

  static getTree(payload: TreeRequest, options?: AxiosRequestConfig) {
    return srmInstance.post<Tree<TreeNode>[]>('/tree', payload, options);
  }

  static getTreeUISchema(payload: any, options?: AxiosRequestConfig) {
    return srmInstance.post<TreeResponse[]>(
      '/tree/ui_schema',
      payload,
      options,
    );
  }

  static getTreeByQueryId(payload: TreeQueryID, options?: AxiosRequestConfig) {
    return srmInstance.post<Tree<TreeNode>>('/tree/query_id', payload, options);
  }

  static getCachedTreeByQueryId(
    payload: TreeQueryID,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<Tree<TreeNode>>(
      '/cached_tree/query_id',
      payload,
      options,
    );
  }

  static getTreeExport(
    payload: TreeExportRequest,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post('/tree/export/ui_schema', payload, {
      ...options,
      responseType: 'blob',
    });
  }

  static getReportValues(
    payload: TreeExportRequest,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<ReportValues>(
      '/tree/report/ui_schema',
      payload,
      options,
    );
  }
}
